import {DomainObject} from 'shared/store';
import {observable, makeObservable} from 'mobx';
import TimeTrackingDimensionValue from './TimeTrackingDimensionValue';

class TimeTrackingDimension extends DomainObject {
  name;
  order;
  values;

  _relations = {
    values: [TimeTrackingDimensionValue]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      order: observable,
      values: observable
    });

    this.merge(other);
  }
}

export default TimeTrackingDimension;
